import { datadogRum } from '@datadog/browser-rum';
import axios from 'axios';

import { getAxiosError } from './getAxiosError';

interface ErrorTrackingParams {
  error: unknown;
  where: string;
  context: unknown;
  showErrorObj?: boolean;
}

export const sendToErrorTracking = ({
  error,
  where,
  context,
  showErrorObj,
}: ErrorTrackingParams) => {
  if (axios.isAxiosError(error) && error.code != 'ERR_NETWORK') {
    datadogRum.addError(error, {
      where,
      context,
      error: {
        message: getAxiosError(error).response?.data.message,
        description: showErrorObj ?? error,
      },
    });

    return;
  }

  const err = error as Error;

  datadogRum.addError(err, {
    where,
    context,
    error: {
      message: err.message,
      description: showErrorObj ?? err,
    },
  });
};
